export default __webpack_public_path__ + "static/media/Chat_icon.b7530b80.png";